import { useState, useEffect, useRef } from "react";

export const useMobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMenuToggle = () => {
    setIsMenuOpen((open) => {
      if (open) setActiveSubmenu(null);
      return !open;
    });
  };

  const handleSubmenuToggle = (menuKey: string, hasSubmenu: boolean) => {
    if (hasSubmenu) {
      setActiveSubmenu((prev) => (prev === menuKey ? null : menuKey));
    } else {
      setActiveSubmenu(null);
      setIsMenuOpen(false);
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveSubmenu(null);
  };

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleDocumentClick);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  return {
    isMenuOpen,
    activeSubmenu,
    containerRef,
    handleMenuToggle,
    handleSubmenuToggle,
    closeMenu,
    setIsMenuOpen,
  };
};
